<template>
  <b-card v-if="!rowsWithError">
    <loading :active.sync="loading"></loading>

    <b-form @submit.stop.prevent>
      <b-form-group>
        <div class="my-2">Step 1: Choose whether you want to insert or update Chatter.</div>
        <b-form-radio-group
          id="type"
          name="type"
          v-model="type"
          v-validate="{ required: true }"
          :state="validateState('type')"
          :options="types">
          <b-form-invalid-feedback id="type-feedback"
                                   :state="validateState('type')">
            Please select one
          </b-form-invalid-feedback>
        </b-form-radio-group>
      </b-form-group>

      <b-form-group>
        <div class="mb-2">Step 2: Download a template to enter data</div>
        <b-button @click="downloadTemplate">Download Template</b-button>
      </b-form-group>

      <b-form-group>
        <div class="mb-2">Step 3: Upload the template</div>
        <b-form-file ref="file"
                     id="file"
                     name="file"
                     class="w-50"
                     v-validate="{ required: true }"
                     :state="validateState('file')"
                     v-model="file"></b-form-file>
        <b-form-invalid-feedback id="file-feedback">
          Please upload a file
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group>
        <b-button variant="secondary"
                  @click="pushRoute('/chatter')">Cancel
        </b-button>
        <b-button variant="primary"
                  class="ml-2"
                  @click="upload">Upload
        </b-button>
      </b-form-group>
    </b-form>
  </b-card>

  <b-card v-else>
    <div class="table-wrapper">
      <b-table bordered
               hover
               head-variant="light"
               :items="rowsWithError">
        <template #cell(errors)="row">
          <div v-html="addLineBreaks(row.value)"></div>
        </template>
      </b-table>
    </div>
  </b-card>
</template>

<script>
import Loading from "vue-loading-overlay";

export default {
  components: { Loading },
  data() {
    return {
      loading: false,
      type: null,
      file: null,
      types: [
        { text: "Insert", value: "insert" },
        { text: "Update", value: "update" },
      ],
      templates: {
        insert: 'chatter_insert_template.xlsx',
        update: 'chatter_update_template.xlsx'
      },
      rowsWithError: null
    }
  },
  methods: {
    async downloadTemplate() {
      try {
        let result = await this.$validator.validate('type');
        if (!result) return;

        // Fetch template file
        let template = this.templates[this.type];
        let response = await axios.get(`chatter/retrieveFile/${template}`, {
          responseType: 'blob',
          headers: { Authorization: accessToken() }
        });

        // Create an url and download the file
        let url = URL.createObjectURL(response.data);
        let link = document.createElement('a');
        link.href = url;
        link.download = template;
        link.click();
      } catch (error) {
        await this.showError(error);
      }
    },
    async upload(event) {
      event.preventDefault();
      let result = await this.$validator.validate();
      if (!result) return;

      try {
        this.loading = true;
        let data = new FormData();
        data.append('template', this.file);
        data.append('type', this.type);

        // Submit a new chat
        let validationResponse = await axios.post('chatter/template/validate', data, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: accessToken()
          }
        });
        let validationResult = JSON.parse(validationResponse.data.data);
        let rowsWithError = validationResult.filter(result => result.errors !== '');
        this.rowsWithError = validationResult;
        console.log(rowsWithError);
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
      }
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref);
      }
      return null;
    },
    addLineBreaks(text) {
      return text.replace(/\n/g, '<br>');
    },
  }
}
</script>